/**
 * Collection name row with optional market-specific lead dimension.
 * Hides lead dimension when it cannot fit on one line beside the collection name.
 */
export default () => ({
  showLeadDimension: false,

  checkFit() {
    const row = this.$el
    const collectionName = this.$refs.collectionName
    const leadDimension = this.$refs.leadDimension
    if (!collectionName || !leadDimension) return

    const gap =
      parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) ||
      0
    const rowWidth = row.clientWidth
    const nameWidth = collectionName.scrollWidth

    const measurer = document.createElement("span")
    measurer.className = leadDimension.className
    measurer.textContent = leadDimension.textContent
    measurer.setAttribute("aria-hidden", "true")
    measurer.style.cssText =
      "position:absolute;visibility:hidden;white-space:nowrap;pointer-events:none;"
    row.appendChild(measurer)
    const leadWidth = measurer.offsetWidth
    row.removeChild(measurer)

    this.showLeadDimension = nameWidth + gap + leadWidth <= rowWidth
  },
})
